import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatSelectModule } from '@angular/material/select';
import { TagService } from '../../../../core/api/tag.service';
import { ExpanseCategoryService } from '../../../../core/api/expanse-category.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TeamService } from '../../../../core/api/team.service';
import { HelpersService } from '../../../../core/services/helpers.service';
import { ConfirmDialogComponent } from '../../../../components/confirm-dialog/confirm-dialog.component';
import { LoadingService } from '../../../../core/services/loading.service';

@Component({
  selector: 'app-action-tag',
  standalone: true,
  imports: [
    CommonModule,
    MatSelectModule,
    MatDividerModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './action-tag.component.html',
  styleUrl: './action-tag.component.scss',
})
export class ActionTagComponent {
  m: any;
  id: any;
  form: FormGroup;
  teams: any[] = [];
  expanseCategories: any[] = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private helpers: HelpersService,
    private fb: FormBuilder,
    private router: Router,
    private tagService: TagService,
    private dialog: MatDialog,
    private teamService: TeamService,
    private expanseCategoryService: ExpanseCategoryService,
    private loadingService: LoadingService
  ) {
    this.m = this.activatedRoute.snapshot.queryParams['m'];
    this.id = this.activatedRoute.snapshot.queryParams['id'];
    this.form = this.fb.group({
      name: [null, [Validators.required]],
      budget: [null],
      description: [null, [Validators.required]],
      teams: [[]],
      expanse_categories: [[]],
    });
  }

  ngOnInit(): void {
    const teamsPromise = this.getTeams();
    const expanseCategoriesPromise = this.getExpanseCategories();
    const dataByIdPromise = this.getDataById();

    Promise.all([
      teamsPromise,
      expanseCategoriesPromise,
      dataByIdPromise,
    ]).catch((error) => {
      this.helpers.sbError('Terjadi kesalahan saat memuat data.');
    });
  }

  getTeams(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.loadingService.startLoading();
      this.teamService.getAllData().then(
        (res) => {
          this.loadingService.endLoading();
          this.teams = res;
          resolve();
        },
        (error) => {
          this.loadingService.endLoading();
          this.helpers.sbError(error.message);
          reject(error);
        }
      );
    });
  }

  getExpanseCategories(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.loadingService.startLoading();
      this.expanseCategoryService.getAllData().then(
        (res) => {
          this.loadingService.endLoading();
          this.expanseCategories = res;
          resolve();
        },
        (error) => {
          this.loadingService.endLoading();
          this.helpers.sbError(error.message);
          reject(error);
        }
      );
    });
  }

  getDataById(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.id) {
        this.loadingService.startLoading();
        this.tagService.getById(this.id).then(
          (data) => {
            this.loadingService.endLoading();
            if (data.tag_teams?.length) {
              data['teams'] = data.tag_teams.map((item: any) => item.team.id);
            }
            if (data.tag_expanse_category?.length) {
              data['expanse_categories'] = data.tag_expanse_category.map(
                (item: any) => item.expanseCategory.id
              );
            }
            this.form.patchValue(data);
            resolve();
          },
          (error) => {
            this.loadingService.endLoading();
            this.helpers.sbError(error.message);
            reject(error);
          }
        );
      } else {
        resolve();
      }
    });
  }

  submit() {
    if (this.form.valid) {
      this.dialog
        .open(ConfirmDialogComponent, {
          width: '545px',
          maxHeight: '95vh',
          panelClass: 'confirm-dialog',
          data: {
            title: `Confirm ${this.m == 'add' ? 'Add New Tag' : 'Edit Tag'}`,
            message: `Changes to the tag cannot be undone once saved. Are you sure you want to proceed?`,
          },
        })
        .afterClosed()
        .subscribe((result: any) => {
          if (result) {
            if (this.m == 'add') {
              this.loadingService.startLoading();
              this.tagService
                .insert(this.form.value)
                .then(() => {
                  this.loadingService.endLoading();
                  this.helpers.sbSuccess('Tag berhasil ditambahkan!');
                  this.router.navigate(['/dashboard/tag']);
                })
                .catch((error) => {
                  this.loadingService.endLoading();
                  this.helpers.sbError(error.message);
                });
            } else if (this.m == 'edit' && this.id) {
              this.loadingService.startLoading();
              this.tagService
                .updateById(this.id, this.form.value)
                .then(() => {
                  this.loadingService.endLoading();
                  this.helpers.sbSuccess('Tag berhasil diperbarui!');
                  this.router.navigate(['/dashboard/tag']);
                })
                .catch((error) => {
                  this.loadingService.endLoading();
                  this.helpers.sbError(error.message);
                });
            }
          }
        });
    } else {
      this.helpers.sbError('Lengkapi form terlebih dahulu!');
    }
  }

  cancel() {
    this.router.navigate(['/dashboard/tag']);
  }
}
